import dynamic from "next/dynamic";

export const DynamicContent021 = dynamic(() => import("./Content021"), {
  suspense: true,
});
